/**
 * @description Triggered to close Wallet Modal
 * @example
 * // Close Wallet Modal
 * window.caiEventBus.emit('wallet:close')
 *
 * // Listen
 * window.caiEventBus.on('wallet:close', function() { ... })
 */
const CLOSE_WALLET = 'wallet:close';
const OPEN_WALLET = 'wallet:open';

/**
 * a request event to get wallet payment information data
 */
const WALLET_GET_PAYMENTS_INFORMATION_REQUEST = 'wallet:getPaymentsInformation:request';

/**
 * a completed event to Wallet Manager when wallet payment information data is retrieved
 */
const WALLET_GET_PAYMENTS_INFORMATION_COMPLETED = 'wallet:getPaymentsInformation:completed';

/**
 * an event to check payments info is fetched/ready for use
 */
const WALLET_ENSURE_PAYMENTS_INFO_REQUEST = 'wallet:ensurePaymentsInfo:request';

/**
 * an event sent by Wallet Manager when payments info is successfully fetched
 */
const WALLET_ENSURE_PAYMENTS_INFO_COMPLETED = 'wallet:ensurePaymentsInfo:completed';

/**
 * requests Wallet Manager to reset consumer Id
 */
const WALLET_UPDATE_DATA_AFTER_LOGIN_REQUEST = 'wallet:updateDataAfterLogin:request';

/**
 * requests Wallet Manager to reset consumer Id
 */
const WALLET_UPDATE_DATA_AFTER_LOGIN_COMPLETE = 'wallet:updateDataAfterLogin:complete';

/**
 * requests Wallet Manager to reset consumer Id
 */
const WALLET_RESET_CONSUMER_ID_REQUEST = 'wallet:resetConsumerId:request';

/**
 * requests Wallet Manager to fetch trade ins
 */
const WALLET_GET_KBB_TRADE_INS_REQUEST = 'wallet:getTradeIns:request';

/**
 * an event sent by Wallet Manager when trade ins are successfully fetched
 */
const WALLET_GET_KBB_TRADE_INS_COMPLETED = 'wallet:getTradeIns:completed';

/**
 * requests Wallet Manager to Wallet Storage with new Payments Info
 */
const WALLET_UPDATE_WALLET_STORAGE_REQUEST = 'wallet:updateWalletStorage:request';

/**
 * an event sent by Wallet Manager when Wallet Storage is succefully updated
 */
const WALLET_UPDATE_WALLET_STORAGE_COMPLETED = 'wallet:updateWalletStorage:completed';

/**
 * requests Wallet Manager to update Payments Info
 */
const WALLET_UPDATE_PAYMENTS_INFO_REQUEST = 'wallet:updatePaymentsInfo:request';

/**
 * an event sent by Wallet Manager when Payments Info is updated
 */
const WALLET_UPDATE_PAYMENTS_INFO_COMPLETED = 'wallet:updatePaymentsInfo:completed';

/**
 * requests wallet manager to fetch ICO trade in data
 */
const WALLET_GET_ICO_TRADE_INS_REQUEST = 'wallet:getICOTradeIns:request';

/**
 * an event sent by Wallet Manager when ICO Trade Ins fetch is completed
 */
const WALLET_GET_ICO_TRADE_INS_COMPLETED = 'wallet:getICOTradeIns:completed';

/**
 * Send event to set the wallet error alert
 */
const WALLET_SET_ERROR_ALERT_REQUEST = 'wallet:setErrorAlert:request';

/**
 * Listen for event to set the wallet error alert
 */
const WALLET_SET_ERROR_ALERT_COMPLETED = 'wallet:setErrorAlert:completed';

/**
 * an requests wallet manager to open the SDP
 */
const WALLET_OPEN_SDP_REQUEST = 'wallet:openSdp:request';

/**
 * an event sent by Wallet Manager when the open SDP event has completed
 */
const WALLET_OPEN_SDP_COMPLETED = 'wallet:openSdp:completed';

/**
 * an event sent by Wallet Manager used to trigger analytics events for wallet sync activity
 */
const WALLET_SYNC_OPEN = 'wallet:sync:open';

/**
 * an event sent by Wallet Manager used to trigger analytics events for wallet sync activity
 */
const WALLET_SYNC_CONFIRM = 'wallet:sync:confirm';

/**
 * requests Wallet Manager to validate the deals by vin
 */
const WALLET_VALIDATE_DEALS_BY_VIN_REQUEST = 'wallet:validateDealsByVin:request';

/**
 * requests Wallet Manager to validate the deals by vin
 */
const WALLET_VALIDATE_DEALS_BY_VIN_COMPLETED = 'wallet:validateDealsByVin:completed';

/**
 * Requests a fetch for deal details
 */
const WALLET_GET_DEAL_DETAILS_REQUEST = 'wallet:getDealDetails:request';

/**
 * Requests a fetch for deal details including a specific deal, polling to account for initial save latency
 */
const WALLET_GET_DEAL_DETAILS_WITH_POLLING_REQUEST = 'wallet:getDealDetailsWithPolling:request';

/**
 * Announces deal details fetch has completed
 */
const WALLET_GET_DEAL_DETAILS_COMPLETED = 'wallet:getDealDetails:completed';

/**
 * requests Wallet Manager to reset deal notifications
 */
const WALLET_RESET_DEAL_NOTIFICATION_REQUEST = 'wallet:resetDealNotification:completed';

/**
 * requests Wallet Manager to update a specific set of deal notifications
 */
const WALLET_UPDATE_DEAL_NOTIFICATION_REQUEST = 'wallet:updateDealNotification:request';

/**
 * requests Wallet Manager to call the fetcher to get dealer information
 */
const WALLET_GET_DEALS_WITH_DEALER_INFORMATION_REQUEST = 'wallet:getDealsWithDealerInformation:request';

/**
 * requests Wallet Manager to sent when dealer information are successfully fetched
 */
const WALLET_GET_DEALS_WITH_DEALER_INFORMATION_COMPLETED = 'wallet:getDealsWithDealerInformation:completed';

/**
 * requests to open/trigger email dealer form
 */
const WALLET_EMAIL_DEALER_REQUEST = 'wallet:emailDealer:request';

/**
 * events for payoff quote service
 */
const WALLET_PAYOFF_QUOTE_SERVICE_GET_LENDERS_REQUEST = 'wallet:payoffQuoteService:getLenders:request';
const WALLET_PAYOFF_QUOTE_SERVICE_GET_LENDERS_COMPLETED = 'wallet:payoffQuoteService:getLenders:completed';
const WALLET_PAYOFF_QUOTE_SERVICE_GET_SELECTED_LENDER_REQUEST = 'wallet:payoffQuoteService:getSelectedLender:request';
const WALLET_PAYOFF_QUOTE_SERVICE_GET_SELECTED_LENDER_COMPLETED = 'wallet:payoffQuoteService:getSelectedLender:completed';
const WALLET_PAYOFF_QUOTE_SERVICE_SUBMIT_REQUEST = 'wallet:payoffQuoteService:submit:request';
const WALLET_PAYOFF_QUOTE_SERVICE_SUBMIT_COMPLETED = 'wallet:payoffQuoteService:submit:completed';

/**
 * requests Wallet Manager to retrieve options from VRS service
 */
const WALLET_VRS_OPTIONS_REQUEST = 'wallet:vrsOptions:request';

/**
 * an event sent by Wallet Manager with VRS options
 */
const WALLET_VRS_OPTIONS_COMPLETED = 'wallet:vrsOptions:completed';

/**
 * requests Wallet Manager to get vehicle valuation
 */
const WALLET_VRS_VEHICLE_VALUATION_REQUEST = 'wallet:vrsVehicleValuation:request';

/**
 * an event sent by Wallet Manager with VRS options
 */
const WALLET_VRS_VEHICLE_VALUATION_COMPLETED = 'wallet:vrsVehicleValuation:completed';

/**
 * requests Wallet Manager to get inventory payments
 */
const WALLET_GET_INVENTORY_PAYMENTS_REQUEST = 'wallet:getInventoryPayments:request';

/**
 * an event sent by Wallet Manager with payments data
 */
const WALLET_GET_INVENTORY_PAYMENTS_COMPLETED = 'wallet:getInventoryPayments:completed';

/**
 * Requests that Wallet Manager create and store a new wallet ID
 */
const WALLET_CREATE_ID_REQUEST = 'wallet:createWalletId:request';

/**
 * Send completed event upon successfully creating a wallet ID
 */
const WALLET_CREATE_ID_COMPLETED = 'wallet:createWalletId:completed';

/**
 * Requests Wallet Manager to retrieve nds config data or pass on external config
 */
const UDS_CONFIG_REQUEST = 'uds:calcConfig:request';

/**
 * Send completed event upon successfully nds config data is retrieved
 */
const UDS_CONFIG_COMPLETED = 'uds:calcConfig:completed';

/**
 * Requests Wallet Manager to update nds config
 */
const UDS_CONFIG_UPDATE_REQUEST = 'uds:calcConfigUpdate:request';

/**
 * Send completed event upon successfully nds config data is retrieved
 */
const UDS_CONFIG_UPDATE_COMPLETED = 'uds:calcConfigUpdate:completed';

/**
 * Send payment calculation response data and deal data upon each nds interaction
 */
const UDS_PAYMENT_CALC_RESPONSE_UPDATE = 'uds:PaymentCalcResponse:Update';

/**
 * Send pencil data upon each nds interaction
 */
const UDS_PENCILING_DATA_UPDATED = 'uds:calcPencilingDataUpdate:updated';

/**
 * Requests payment data update
 */
const UDS_PAYMENT_UPDATE_REQUEST = 'uds:paymentUpdate:request';

/**
 * Sends route (required) and additional (optional) props to then build the init object and initialize the SDP widget via wallet-manager
 */
const UDS_OPEN_SDP_REQUEST = 'uds:openSdp:request';

/**
 * Sends name, action, and data from the SDP widget onTrack event
 */
const UDS_SDP_ONTRACK_COMPLETED = 'uds:sdpOnTrack:completed';

/**
 * Event sent by the external tenant to set the deal type (`finance`, `lease`, `cash`)
 */
const UDS_SET_DEALTYPE_REQUEST = 'uds:setDealType:request';

/**
 * Event sent by the UDS calculator to indicate that the deal type has been set successfully
 */
const UDS_SET_DEALTYPE_COMPLETED = 'uds:setDealType:completed';

/**
 * Event sent by the external tenant to retrieve available incentives
 */
const UDS_GET_INCENTIVES_REQUEST = 'uds:getIncentives:request';

/**
 * Event sent by the UDS calculator when incentives data has been retrieved successfully
 */
const UDS_GET_INCENTIVES_COMPLETED = 'uds:getIncentives:completed';

/**
 * Event sent by the UDS calculator to request verification of selected payment criteria
 */
const UDS_CTA_CLICK_REQUEST = 'uds:ctaClick:request';

/**
 * Event sent by the external tenant when the verification of selected payment criteria has been completed
 */
const UDS_CTA_CLICK_COMPLETED = 'uds:ctaClick:completed';
export { CLOSE_WALLET, OPEN_WALLET, UDS_CONFIG_COMPLETED, UDS_CONFIG_REQUEST, UDS_CONFIG_UPDATE_COMPLETED, UDS_CONFIG_UPDATE_REQUEST, UDS_CTA_CLICK_COMPLETED, UDS_CTA_CLICK_REQUEST, UDS_GET_INCENTIVES_COMPLETED, UDS_GET_INCENTIVES_REQUEST, UDS_OPEN_SDP_REQUEST, UDS_PAYMENT_CALC_RESPONSE_UPDATE, UDS_PAYMENT_UPDATE_REQUEST, UDS_PENCILING_DATA_UPDATED, UDS_SDP_ONTRACK_COMPLETED, UDS_SET_DEALTYPE_COMPLETED, UDS_SET_DEALTYPE_REQUEST, WALLET_CREATE_ID_COMPLETED, WALLET_CREATE_ID_REQUEST, WALLET_EMAIL_DEALER_REQUEST, WALLET_ENSURE_PAYMENTS_INFO_COMPLETED, WALLET_ENSURE_PAYMENTS_INFO_REQUEST, WALLET_GET_DEALS_WITH_DEALER_INFORMATION_COMPLETED, WALLET_GET_DEALS_WITH_DEALER_INFORMATION_REQUEST, WALLET_GET_DEAL_DETAILS_COMPLETED, WALLET_GET_DEAL_DETAILS_REQUEST, WALLET_GET_DEAL_DETAILS_WITH_POLLING_REQUEST, WALLET_GET_ICO_TRADE_INS_COMPLETED, WALLET_GET_ICO_TRADE_INS_REQUEST, WALLET_GET_INVENTORY_PAYMENTS_COMPLETED, WALLET_GET_INVENTORY_PAYMENTS_REQUEST, WALLET_GET_KBB_TRADE_INS_COMPLETED, WALLET_GET_KBB_TRADE_INS_REQUEST, WALLET_GET_PAYMENTS_INFORMATION_COMPLETED, WALLET_GET_PAYMENTS_INFORMATION_REQUEST, WALLET_OPEN_SDP_COMPLETED, WALLET_OPEN_SDP_REQUEST, WALLET_PAYOFF_QUOTE_SERVICE_GET_LENDERS_COMPLETED, WALLET_PAYOFF_QUOTE_SERVICE_GET_LENDERS_REQUEST, WALLET_PAYOFF_QUOTE_SERVICE_GET_SELECTED_LENDER_COMPLETED, WALLET_PAYOFF_QUOTE_SERVICE_GET_SELECTED_LENDER_REQUEST, WALLET_PAYOFF_QUOTE_SERVICE_SUBMIT_COMPLETED, WALLET_PAYOFF_QUOTE_SERVICE_SUBMIT_REQUEST, WALLET_RESET_CONSUMER_ID_REQUEST, WALLET_RESET_DEAL_NOTIFICATION_REQUEST, WALLET_SET_ERROR_ALERT_COMPLETED, WALLET_SET_ERROR_ALERT_REQUEST, WALLET_SYNC_CONFIRM, WALLET_SYNC_OPEN, WALLET_UPDATE_DATA_AFTER_LOGIN_COMPLETE, WALLET_UPDATE_DATA_AFTER_LOGIN_REQUEST, WALLET_UPDATE_DEAL_NOTIFICATION_REQUEST, WALLET_UPDATE_PAYMENTS_INFO_COMPLETED, WALLET_UPDATE_PAYMENTS_INFO_REQUEST, WALLET_UPDATE_WALLET_STORAGE_COMPLETED, WALLET_UPDATE_WALLET_STORAGE_REQUEST, WALLET_VALIDATE_DEALS_BY_VIN_COMPLETED, WALLET_VALIDATE_DEALS_BY_VIN_REQUEST, WALLET_VRS_OPTIONS_COMPLETED, WALLET_VRS_OPTIONS_REQUEST, WALLET_VRS_VEHICLE_VALUATION_COMPLETED, WALLET_VRS_VEHICLE_VALUATION_REQUEST };
